import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ContractExecutionPage } from "@/features/contracts/contract-execution-page";
import { ensureElementVisible } from "@/lib/route-guards";

// Deep-linkowalne: scope (zakres), rok/okres (filtry) i kontrakt (tryb
// szczegolow per apteka). Zly param z zakladki nie moze wywalic trasy (catch).
const searchSchema = z.object({
	scope: z.string().optional().catch(undefined),
	rok: z.coerce.number().int().optional().catch(undefined),
	// union+transform: parser TanStacka konwertuje wartosci numeryczne na number
	okres: z.union([z.string(), z.number()]).transform(String).optional().catch(undefined),
	kontrakt: z.coerce.number().int().optional().catch(undefined),
});

export type ContractExecutionSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/kontrakty/wykonanie")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.wykonanie",
			location.pathname,
		);
	},
	component: ContractExecutionPage,
	validateSearch: (search: Record<string, unknown>): ContractExecutionSearch =>
		searchSchema.parse(search),
});
